import React from "react";
import { Phone, Mail, MapPin } from "lucide-react";
import ContactForm from "./ContactForm"; // adjust path if needed
import { motion } from "framer-motion";

const ContactOne = () => {
  return (
    <section className="bg-gradient-to-b from-gray-50 to-gray-100 py-16 px-6 lg:px-12 xl:px-20">
      <div className="max-w-7xl mx-auto grid grid-cols-1 lg:grid-cols-2 gap-12">
        {/* Left Content */}
        <motion.div 
          initial={{ opacity: 0, x: -50 }} 
          whileInView={{ opacity: 1, x: 0 }} 
          transition={{ duration: 0.8 }}
        >
          <h2 className="text-3xl md:text-4xl 2xl:text-5xl font-bold text-gray-800 mb-6">
            Our Team Is Here for You
          </h2>
          <p className="text-gray-700 mb-4 text-lg leading-relaxed">
            If your child suffered a birth injury, you may wonder whether proper medical care could have prevented it. A birth injury claim may help you answer that question.
          </p>
          <p className="text-gray-700 mb-4 text-lg leading-relaxed">
            Filing a claim may seem confusing and overwhelming, but our trusted birth injury attorneys are here to help you every step of the way. Call us today or fill out the form on this page.
          </p>
          <p className="text-gray-800 font-semibold mb-8 text-lg">
            Don’t be afraid to tell your story or ask us questions. We’re here to serve you!
          </p>

          {/* Contact Details */}
          <div className="space-y-6">
            <motion.div 
              whileHover={{ scale: 1.03, boxShadow: "0 8px 20px rgba(0,0,0,0.1)" }} 
              className="p-4 bg-white rounded-xl border border-gray-200 transition-all"
            >
              <h3 className="text-lg font-semibold text-gray-800 mb-2">
                Contact Us for Legal Help Today
              </h3>
              <div className="flex items-center gap-3 text-[#023437] font-semibold text-lg hover:text-teal-700 transition-colors">
                <Phone className="w-5 h-5" />
                <a href="tel:8882011350" className="hover:underline">
                  (888)-201-1350
                </a>
              </div>
            </motion.div>

            <motion.div 
              whileHover={{ scale: 1.03, boxShadow: "0 8px 20px rgba(0,0,0,0.1)" }} 
              className="p-4 bg-white rounded-xl border border-gray-200 transition-all"
            >
              <h4 className="text-gray-800 font-medium mb-2">
                Other Ways to Contact Us:
              </h4>
              <div className="space-y-3 text-gray-700">
                <div className="flex items-center gap-3 hover:text-teal-700 transition-colors">
                  <Mail className="w-5 h-5 text-[#023437]" />
                  <a href="mailto:contact@childbirthinjuries.com" className="hover:underline">
                    contact@childbirthinjuries.com
                  </a>
                </div>
                {/* Optional Address */}
                {/* <div className="flex items-start gap-3 hover:text-teal-700 transition-colors">
                  <MapPin className="w-5 h-5 text-[#023437] mt-1" />
                  <address className="not-italic">
                    1330 Boylston Street, Suite 400<br/>
                    Chestnut Hill, MA 02467
                  </address>
                </div> */}
              </div>
            </motion.div>
          </div>
        </motion.div>

        {/* Contact Form */}
        <motion.div 
          initial={{ opacity: 0, x: 50 }} 
          whileInView={{ opacity: 1, x: 0 }} 
          transition={{ duration: 0.8 }}
        >
          <ContactForm />
        </motion.div>
      </div>
    </section>
  );
};

export default ContactOne;
